import React from "react";
import Image from "next/image";

const AboutBannerMobile = () => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    let yOffset = 0;
    if (window.innerWidth <= 768) {
      // Mobile version
      yOffset = -100;
    } else {
      // Desktop version
      yOffset = -150;
    }

    if (section) {
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };
  return (
    <>
      {/* // Mobile version */}

      <div className="w-full h-auto py-10 relative bg-center square_grid_bg">
        <div className="w-full flex justify-center mb-8">
          <Image
            src="/about-us/bg-des.png"
            alt="Special Offer"
            className="w-[326px] h-[247px]"
            width={955}
            height={911}
            priority
          />
        </div>

        <div className="text-center flex flex-col items-center justify-center">
          <h1 className="text-[44px] tracking-[-1.76px] font-bold leading-[120%] bg-gradient-to-r from-[#082647] to-[#3174d6] bg-clip-text text-transparent mb-4">
            Inspiring & <br />
            Enabling Talent
            <span className="text-[18px] tracking-[-0.72px] font-medium leading-[130%] text-black block mt-2">
              to Achieve Their Highest Potential
            </span>
          </h1>

          <div
            className="grp_btn flex items-center justify-center cursor-pointer  rounded-[8px] w-[162px] h-[36px]"
            onClick={() => scrollToSection("problem_statement")}
          >
            <p className="new__discover_btn font-medium text-[14px] text-center">
              Learn More
            </p>
          </div>
        </div>

        <div id="problem_statement" className="w-full"></div>
      </div>
    </>
  );
};

export default AboutBannerMobile;
